<template>
  <div class="product-series">
    <div class="header-search">
      <span class="total-label">{{ $t('Fota.firmwareModelTotal') }}</span>
      <span class="total-value">{{ total }}</span>
      <CommonForm
        class="common-form"
        @search="formSearch"
        :form-json="formjson"
        :autoSearch="false"
      />
    </div>
    <div class="table">
      <el-row :gutter="24" type="flex" style="flex-wrap: wrap;">
        <el-col :span="8" v-if="addRole">
          <div class="add-card" @click="add">
            <hl-button type="special" circle icon="el-icon-plus" needShadow> </hl-button>
            <p>{{ $t('Fota.addFirmwareModel') }}</p>
          </div>
        </el-col>
        <el-col :span="8" v-for="item in tableData" :key="item.id">
          <div class="card">
            <div class="series-desc">
              <div class="name">
                {{ item.name }}
                <hl-tag
                  plain
                  :color="getColor()"
                  :borderColor="getColor()"
                  :backgroundColor="getColor()"
                  style="vertical-align: middle;"
                  >http</hl-tag
                >
              </div>
              <div class="code"><span class="code-tag">key</span>{{ item.signKey }}</div>
              <div class="count">{{ item.deviceCount }}</div>
              <div class="hint">{{ $t('Fota.useDevice') }}</div>
            </div>
            <div class="operation">
              <hl-button
                type="special"
                circle
                onlyIcon
                :tip="$t('Common.detail')"
                v-if="detailRole"
                @click="handleDetail(item)"
              >
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-detail_16"></use>
                </svg>
              </hl-button>
              <hl-button
                type="special"
                circle
                onlyIcon
                :tip="$t('Common.edit')"
                v-if="updateRole"
                @click="handleEdit(item)"
              >
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-edit_16"></use>
                </svg>
              </hl-button>
              <hl-button
                type="special"
                circle
                onlyIcon
                :tip="$t('Common.delete')"
                v-if="deleteRole"
                @click="handleDelete(item)"
              >
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-del_24"></use>
                </svg>
              </hl-button>
              <svg class="icon expand-icon" aria-hidden="true">
                <use xlink:href="#icon-more"></use>
              </svg>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <Dialog :row="row" @refresh="formSearch()" v-if="visible" :visible.sync="visible" />
    <Detail :row="row" v-if="detailVisible" :visible.sync="detailVisible" />
  </div>
</template>

<script>
import Tag from '@/components/CommonTable/Tag'
import Dialog from './Dialog'
import Detail from './Detail'

import formjson from './Model/Formjson.Index'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'

import { blueColor } from '@/style/var.scss'
export default {
  mixins: [getRoleFromPath],
  components: {
    'hl-tag': Tag,
    Dialog,
    Detail
  },
  data() {
    return {
      formjson,
      total: 0,
      tableData: [],
      row: {},
      visible: false,
      detailVisible: false
    }
  },
  created() {
    this.formSearch()
  },
  computed: {
    /********* 权限 ***********/
    // this.role 计算属性通过mixins: [getRoleFromPath] 注入
    // 导出权限
    roleChildList() {
      return this.role.childList
    },
    // 新建
    addRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'add')
      return val ? val.isPermission == 'Y' : false
    },
    // 编辑
    updateRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'update')
      return val ? val.isPermission == 'Y' : false
    },
    // 删除
    deleteRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'del')
      return val ? val.isPermission == 'Y' : false
    },
    // 详情
    detailRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'detail')
      return val ? val.isPermission == 'Y' : false
    }
    /********* 权限 ***********/
  },
  methods: {
    formSearch(data) {
      const params = {
        ...data
      }

      this.$ajax.get(this.$api.fota.firmware_page, params).then((res) => {
        this.tableData = res.data
        this.total = res.data.length ? res.data.length : 0
      })
    },
    getColor() {
      return blueColor
    },
    add() {
      this.row = {}
      this.visible = true
    },
    handleDetail(row) {
      this.row = row
      this.detailVisible = true
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    handleDelete(row) {
      this.$confirm(`${this.$t('Common.operationTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: `${this.$t('Common.confirm')}`,
        cancelButtonText: `${this.$t('Common.cancel')}`,
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.fota.firmware_remove, params)
            .then(() => {
              this.$message.success(`${this.$t('Common.delSuccess')}`)
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.product-series {
  position: relative;
  .header-search {
    position: absolute;
    top: -58px;
    right: 0;
    .total-label {
      display: inline-block;
      margin-right: 8px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      color: #666666;
      vertical-align: top;
    }
    .total-value {
      display: inline-block;
      margin-right: 48px;
      height: 32px;
      line-height: 32px;
      font-size: 24px;
      font-weight: 600;
      color: #333333;
      vertical-align: top;
    }
    .common-form {
      display: inline-block;
      vertical-align: top;
    }
  }
  .card {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px -2px 20px 0px rgba(34, 42, 57, 0.05);
    border-radius: 16px;
  }
  .table {
    .el-col {
      padding-bottom: 24px;
    }
    .add-card {
      height: 100%;
      min-height: 193px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 2.5px dashed rgba(218, 223, 230, 1);
      border-radius: 16px;
      cursor: pointer;
      &:hover {
        background: rgba(255, 255, 255, 0.5);
      }
      p {
        margin-top: 8px;
        font-size: 16px;
        color: #333333;
        text-align: center;
      }
    }
    .card {
      position: relative;
      display: flex;
      &:hover {
        box-shadow: 0px 10px 32px 0px rgba(23, 38, 64, 0.12);
        .operation {
          .hl-button {
            visibility: visible;
          }
          .expand-icon {
            color: $--color-blue;
          }
        }
      }
      .series-desc {
        .name {
          font-size: 18px;
          color: #333333;
          font-weight: 600;
        }
        .code {
          margin-top: 8px;
          color: #999999;
          margin-bottom: 32px;
          .code-tag {
            display: inline-block;
            margin-right: 4px;
            width: 27px;
            height: 16px;
            line-height: 16px;
            font-size: 12px;
            text-align: center;
            color: #339dff;
            background: rgba(51, 157, 255, 0.15);
            border-radius: 4px 4px 0px 4px;
          }
        }
        .count {
          font-family: Barlow-SemiBold;
          font-size: 48px;
          color: #333333;
          letter-spacing: 0;
          line-height: 48px;
          font-weight: 600;
          margin-bottom: 4px;
        }
        .hint {
          color: #666666;
        }
      }
    }
    .operation {
      position: absolute;
      right: 25px;
      bottom: 24px;
      color: #a1a5ad;
      font-size: 24px;
      cursor: pointer;
      .hl-button {
        visibility: hidden;
        font-size: 16px;
        padding: 8px;
        vertical-align: middle;
      }
    }
  }
}
</style>
